import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import NumberFormat from 'react-number-format';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import {
    GridList,
    GridTile,
} from 'material-ui/GridList';

import { Utils } from '../../services';

class InscricaoStepCartao extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nome: '',
            numeroCartao: '',
            email: '',
            mesVencimento: '',
            anoVencimento: '',
            codigoSeguranca: '',
            cpf: '',
            dataNascimento: '',
        };
        // this.state = {
        //     nome: 'Claudio Scheer',
        //     numeroCartao: '4111 1111 1111 1111',
        //     email: 'claudiojunior@setrem.com.br',
        //     mesVencimento: '12',
        //     anoVencimento: '2030',
        //     codigoSeguranca: '123',
        //     cpf: '03954555026',
        //     dataNascimento: '29051997',
        // };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        Utils.showLoading(false);
    }

    async onPagarComCartao(event) {
        event.preventDefault();
        const {
            nome,
            numeroCartao,
            mesVencimento,
            anoVencimento,
            codigoSeguranca,
            email,
            cpf,
            dataNascimento,
        } = this.state;

        if (!Utils.isCPFValido(cpf)) {
            Utils.showToast('CPF é inválido.');
        } else if (!Utils.isDataValida(dataNascimento)) {
            Utils.showToast('Data de nascimento é inválida.');
        } else if (!Utils.isEmailValido(email)) {
            Utils.showToast('E-mail é inválido.');
        } else {
            await this.props.onPagarComCartao(nome, numeroCartao, mesVencimento, anoVencimento, codigoSeguranca, email, cpf, dataNascimento);
        }
    }

    validarCPF(value) {
        if (!Utils.isCPFValido(value)) {
            this.setState({ cpfErrorText: 'CPF inválido', cpf: value });
            return false;
        }
        this.setState({ cpfErrorText: '', cpf: value });
        return true;
    }

    validarEmail(value) {
        if (!Utils.isEmailValido(value)) {
            this.setState({ emailErrorText: 'E-mail inválido', email: value });
            return false;
        }
        this.setState({ emailErrorText: '', email: value });
        return true;
    }

    render() {
        const {
            nome,
            dataNascimento,
            cpf,
            email,
            cpfErrorText,
            emailErrorText,
            numeroCartao,
            mesVencimento,
            anoVencimento,
            codigoSeguranca,
        } = this.state;

        return (
            <div>
                <form onSubmit={event => this.onPagarComCartao(event)}>
                    <br />
                    <h3>Informações do cartão</h3>
                    <GridList cols={3} cellHeight="auto">
                        <GridTile cols={2}>
                            <GridList cols={3} cellHeight="auto">
                                <GridTile cols={1.5}>
                                    <TextField
                                        floatingLabelText="Nome impresso no cartão"
                                        required
                                        errorText={nome ? '' : 'Campo obrigatório'}
                                        onChange={e => this.setState({ nome: e.target.value })}
                                        value={nome}
                                        fullWidth
                                    />
                                </GridTile>
                                <GridTile cols={1.5}>
                                    <NumberFormat
                                        format="#### #### #### ####"
                                        customInput={TextField}
                                        required
                                        value={numeroCartao}
                                        errorText={numeroCartao ? '' : 'Campo obrigatório'}
                                        floatingLabelText="Número do cartão"
                                        onChange={e => this.setState({ numeroCartao: e.target.value })}
                                        fullWidth
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <NumberFormat
                                        format="##"
                                        customInput={TextField}
                                        required
                                        value={mesVencimento}
                                        errorText={mesVencimento ? '' : 'Campo obrigatório'}
                                        floatingLabelText="Mês de vencimento (MM)"
                                        onChange={e => this.setState({ mesVencimento: e.target.value })}
                                        fullWidth
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <NumberFormat
                                        customInput={TextField}
                                        format="####"
                                        floatingLabelText="Ano de vencimento (AAAA)"
                                        required
                                        value={anoVencimento}
                                        errorText={anoVencimento ? '' : 'Campo obrigatório'}
                                        onChange={e => this.setState({ anoVencimento: e.target.value })}
                                        fullWidth
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <NumberFormat
                                        customInput={TextField}
                                        floatingLabelText="CVC"
                                        required
                                        value={codigoSeguranca}
                                        errorText={codigoSeguranca ? '' : 'Campo obrigatório'}
                                        format="###"
                                        onChange={e => this.setState({ codigoSeguranca: e.target.value })}
                                        fullWidth
                                    />
                                </GridTile>
                                <GridTile cols={1.5}>
                                    <NumberFormat
                                        format="###.###.###-##"
                                        customInput={TextField}
                                        required
                                        fullWidth
                                        value={cpf}
                                        errorText={!cpf ? 'Campo obrigatório' : cpfErrorText}
                                        floatingLabelText="CPF"
                                        onChange={e => this.validarCPF(e.target.value)}
                                    />
                                </GridTile>
                                <GridTile cols={1.5}>
                                    <NumberFormat
                                        floatingLabelText="Data nascimento"
                                        format="##/##/####"
                                        customInput={TextField}
                                        required
                                        fullWidth
                                        value={dataNascimento}
                                        errorText={dataNascimento ? '' : 'Campo obrigatório'}
                                        onChange={e => this.setState({ dataNascimento: e.target.value })}
                                    />
                                </GridTile>
                                <GridTile cols={3}>
                                    <TextField
                                        floatingLabelText="E-mail"
                                        required
                                        fullWidth
                                        errorText={!email ? 'Campo obrigatório' : emailErrorText}
                                        onChange={e => this.validarEmail(e.target.value)}
                                        value={email}
                                    />
                                </GridTile>
                            </GridList>
                        </GridTile>
                        <GridTile cols={1}>
                            <Cards
                                number={numeroCartao}
                                name={nome}
                                expiry={`${mesVencimento}/${anoVencimento}`}
                                cvc={codigoSeguranca}
                            />
                        </GridTile>
                    </GridList>

                    <RaisedButton
                        label="Realizar pagamento"
                        primary
                        type="submit"
                    />
                </form>
            </div>
        );
    }
}

InscricaoStepCartao.propTypes = {
    onPagarComCartao: PropTypes.func.isRequired,
};

export default InscricaoStepCartao;
